import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/employee-management-system/employee-shift-management/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "employee-shift-management" entry is kept); the seo block below is a fallback.

export const employeeShiftManagement: ContentPage = {
  slug: "employee-management-system/employee-shift-management",
  template: "hrmsFeature",
  seo: {
    title: "Efficient Shift Management System for Seamless Operations",
    description: "Automate shift scheduling, manage shift swaps, and track overtime with a powerful shift management system to enhance productivity and reduce conflicts.",
    keywords: [
      "shift management software",
      "employee shift scheduling",
      "shift swap system",
      "automated shift scheduling",
      "employee shift planner",
      "HR shift management system.",
    ],
    ogImage: "/assets/data/seoimages/employee-shift-management.webp",
  },
  leaf: {
    hero: {
      caption: "Shift Management",
      title: "Streamlined Shift Management for Optimized Workforce Operations",
      description: "Automate and organize shift scheduling, manage shift swaps, and ensure proper staffing with a powerful shift management system.",
      h1: "caption",
    },
    split: {
      title: "Automate and Simplify Shift Scheduling",
      bullets: [
        { title: "Automated Shift Scheduling", description: "Create shifts and assign them automatically." },
        { title: "Shift Swap Management", description: "Allow employees to swap or trade shifts easily." },
        { title: "Overtime Calculation", description: "Track and calculate employee overtime." },
        { title: "Shift Notifications", description: "Notify employees of assigned shifts via email/SMS." },
      ],
      image: "/assets/images/img/product/hrms/employeems/employee_shift_management_image.webp",
      imageAlt: "employee-shift-management",
    },
    cardsHeading: {
      title: "Key Features of Employee Management System",
      description: "Optimize Employee management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Attendance Tracking",
        href: "/hrms-software/employee-management-system/attendance-tracking",
        description: "Track and monitor employee attendance with real-time clock-in/out, ensuring precise records for improved productivity and payroll accuracy.",
        image: "/assets/images/img/product/hrms/employeems/attendance_tracking_images.webp",
        imageAlt: "attendance_tracking_key_features",
      },
      {
        title: "Performance Review",
        href: "/hrms-software/employee-management-system/performance-review",
        description: "Track employee performance, set KPIs, and provide feedback with structured review processes for better productivity and growth.",
        image: "/assets/images/img/product/hrms/employeems/performance_review.webp",
        imageAlt: "performance Review",
      },
      {
        title: "Employee Directory",
        href: "/hrms-software/employee-management-system/employee-directory",
        description: "Easily manage employee profiles, personal details, roles, and contact information in a secure and centralized directory for streamlined operations.",
        image: "/assets/images/img/product/hrms/employeems/employee_directory_image.webp",
        imageAlt: "employee_directory_key_features",
      },
      {
        title: "Leave Management",
        href: "/hrms-software/employee-management-system/leave-management",
        description: "Simplify leave requests and approvals with automated workflows, ensuring smooth operations and minimal disruptions.",
        image: "/assets/images/img/product/hrms/employeems/leave_management.webp",
        imageAlt: "leave_management",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Simplify Shift Scheduling for Your Business!",
    relatedBlogs: "static",
    metaKey: "employee-shift-management",
  },
  sections: [],
};
